import React, { useState } from 'react';

const defaultToggleLabels = {
  show: 'Mostrar contraseña',
  hide: 'Ocultar contraseña',
};

const joinClasses = (...classes) => classes.filter(Boolean).join(' ');

const PasswordInputField = ({
  id,
  name,
  value,
  onChange,
  placeholder,
  className = '',
  wrapperClassName = '',
  disabled = false,
  autoComplete,
  ariaInvalid,
  toggleLabels = defaultToggleLabels,
  inputProps = {},
}) => {
  const [isVisible, setIsVisible] = useState(false);

  const handleToggleVisibility = () => {
    setIsVisible((prev) => !prev);
  };

  const currentAriaLabel = isVisible ? toggleLabels.hide : toggleLabels.show;

  return (
    <div className={joinClasses('password-wrapper', wrapperClassName)}>
      <input
        id={id}
        name={name}
        type={isVisible ? 'text' : 'password'}
        className={className}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        aria-invalid={ariaInvalid}
        autoComplete={autoComplete}
        {...inputProps}
      />
      <button
        type="button"
        className="password-toggle"
        onClick={handleToggleVisibility}
        tabIndex={-1}
        aria-label={currentAriaLabel}
      >
        <i className={`fa ${isVisible ? 'fa-eye-slash' : 'fa-eye'}`}></i>
      </button>
    </div>
  );
};

export default PasswordInputField;

